module.exports = __webpack_public_path__ + "img/logo.4aa0452e.jpg";